export default "__VITE_ASSET__B7Kcqi2J__"